import React, { useState,useEffect,useRef } from "react";
import './classes/EditAgentProfile.css';
import Editor from 'react-simple-wysiwyg';
import { configData } from "../config";
import { useNavigate,useLocation  } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Loading from './Loading';
import Link from '@mui/material/Link';
import EditAthlete from "./EditAthlete";

const ViewAthleteProfile = ({uid,username,userLoggedInRoles,userDetails}) => {

    const [activeView, setActiveView] = useState("view");
     const showView = () => {
        const newView = activeView === "view" ? "edit_athlete" : "athlete";
        setActiveView(newView);
    
        navigate(`/user/${uid}/${newView}`);
      };
    
    const location = useLocation();
    
    useEffect(() => {
      if (location.pathname.includes("/edit_athlete")) {
        setActiveView("edit");
      } else {
        setActiveView("view");
      }
    }, [location.pathname]); 
    const successAthleteEditMessage = location.state?.result; 
  
const [successEditMessage, setSuccessEditMessage] = useState('');

        useEffect(() => {
          if (successAthleteEditMessage) {
            setSuccessEditMessage(successAthleteEditMessage);
            getathletedetails();
            window.history.replaceState({}, '');
          }
        }, [successEditMessage, location.state]);

    const [toggles, setToggles] = useState({
        AthleteMainDetails: true,
        athleteprofile:true,
        athletedetails:true,   
        AgentBio: true,
        contactInfo: true,
        socialMediaToggle: true,
    });

    const handleToggle = (key) => {
        setToggles((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const navigate = useNavigate();
    const app_url = configData.APP_URL;

 
    const [agentuploadFiles, setAgentUploadedFiles] = useState([]);

    const [athleteSportList, setAthleteSportList] = useState('');
    const [allAthletes, setAthleteList] = useState([]);
    const [assignedAthletes, setAssignedAthleteList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const loggedin_uid = localStorage.getItem('drupal_uid');
    const [athleteAssets, setAthleteAssets] = useState([]);
    const [socialAssets, setSocialAssets] = useState({});
    const [commonAssets, setCommonAssets] = useState({});

const athleteSportField = athleteAssets?.find(
  (item) => item.key === "field_athlete_sports"
);

const athleteSportlist = athleteSportField?.full_value
  ? athleteSportField.full_value.split(",")
  : [];
const transformData = (dataArray) => {
  return dataArray.reduce((acc, item) => {
    if (item.date || item.time) {
      acc[item.key] = {
        date: item.date,
        time: item.time
      };
    } else {
      acc[item.key] = item.full_value ?? item.value ?? null;
    }
    return acc;
  }, {});
};

const backEndData = transformData(athleteAssets);

const mergedData = {
  ...commonAssets,
  ...backEndData,
};

const sections = [
  {
    key: "field_biography",
    keyToggle: "AgentBio",
    title: "Biography",
    emptyText: "No biography content.",
    customClass: "bio-style"
  },
  {
    key: "field_how_to_contact_client",
    keyToggle: "contactInfo",
    title: "How to Contact",
    emptyText: "No contact info.",
    customClass: "notes-style"
  }
];

const rightSectionFields = [
  { label: "Athlete ID#", key: "field_athelte_id" },
//   { label: "Sport Played", key: "sport_played" },
  { label: "Height / Weight", key: "height_weight" },
  { label: "DOB", key: "field_dob" },
];


   
    
    const getCurrentDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
    };
    const currentFormattedDate = getCurrentDateFormatted();

    const getCurrentBDateFormatted = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    };
    const currentFormattedBDate = getCurrentBDateFormatted();  
    
const parseDate = (dateString) => {
    if (!dateString) return null;

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        const [mm, dd, yyyy] = dateString.split('/');
        dateString = `${yyyy}-${mm}-${dd}`;
    }
    const dateObj = new Date(dateString);
    return isNaN(dateObj) ? null : dateObj;
};

useEffect(() => {
  const fetchData = async () => {
    try {
      await Promise.all([
        getathletedetails(),
        getfieldslist()
      ]);
    } catch (err) {
      console.error(err);
    }
  };

  fetchData();
}, []);
 
 


 async function getathletedetails() { 
  if (uid !== '' || username !== '') {
    try {
      setIsLoading(true);

      const response = await fetch(
        app_url + 'viewprofile/getathletedetails?uid=' + uid
      );

      const responsedata = await response.json();

      if (responsedata.data.result === "Success") {
        setAthleteAssets(responsedata.data.user_athlete_assets || []);
        setSocialAssets(responsedata.data.user_social_media_assets || {});
        setCommonAssets(responsedata.data.user_common_assets || {});
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  }
}
const [athleteType, setAthleteType] = useState({});
async function getfieldslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwfieldlist/getfieldlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
               setAthleteType(responsedata.data.athletetype);
            } 
        } catch (err) {
            
         }
        
  }
 
const getAthleteTypeLabel = (id) => {
    // athletesportList is the state variable where you stored the response.data.athletetype
    if (athleteType && athleteType[id]) {
        return athleteType[id];
    }
    return id; // Fallback to the ID if the label isn't found
};

    const validTypes = [
        'text/plain',
        'image/png',
        'image/jpeg',
        'image/jpg',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
    ];

    const maxSize = 128 * 1024 * 1024;

const getFileIcon = (fileName) => {
  if (!fileName || typeof fileName !== 'string') {
    return '/basic/web/images/image-x-generic.png';
  }

  const extension = fileName.split('.').pop().toLowerCase();

  switch (extension) {
    case 'txt': return '/basic/web/images/text-plain.png';
    case 'pdf': return '/basic/web/images/application-pdf.png';
    case 'docx': return '/basic/web/images/x-office-document.png';
    case 'jpg':
    case 'jpeg':
    case 'png': return '/basic/web/images/image-x-generic.png';
    default: return '/basic/web/images/image-x-generic.png';
  }
};

 
   
    
  



    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (        
                 <>
                    {activeView === "view" ? (<>
                            <div className='viewtab-top-section'>
                                  {successEditMessage && (
                                <div className="set-message-done" style={{marginBottom: "5px"}}>
                                    <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span>&nbsp;
                                    {/* {successEditMessage} */}
                                    <span
                                        dangerouslySetInnerHTML={{ __html: successEditMessage }}
                                    />

                                </div>
                                )}
                                <div>
                                    <div className="edit-agent-prof-editbtn">
                                        <button class="main-app-action-btn edit-fields-btn" onClick={showView}>✎ Edit</button>
                                    </div>
                                    <div 
                                    className={`view-user-profile-section-header agent-section-header ${toggles["AthleteMainDetails"] ? "open" : ""}`}
                                    style={{border: "0px", outline: "1px solid #bbb"}}
                                    >
                                        <div class="app-aspect-content" onClick={() => handleToggle("AthleteMainDetails")}>
                                            <div class="aspect-info">
                                                <span class="view-user-profile-section-heading"><strong>Athlete Profile</strong></span>
                                            </div>
                                        </div>
                                        {toggles.AthleteMainDetails && (
                                            <div class="view-user-profile-section-body-container">
                                                <div class="view-user-profile-section-container user-profile-summary-table user-profile-details user-contact-info">

                                                    <div className="edit-agent-prof-details">
                                                        <div style={{flexShrink: "0"}}>
                                                            <div class="edit-agent-image">
                                                                {userDetails.picture ? (  
                                                                    <><img  src={userDetails.picture} width="100px" height="100px" alt = "user"/></>
                                                                ):(
                                                                    <div className="edit-agent-img-placeholder">No Photo<br />Uploaded</div>
                                                                )}
                                                            </div>
                                                            <div className="agent-img-desc">100–1000px · png/jpg/gif</div>
                                                        </div>
                                                
                                                        <div class="agent-name-loc" style={{marginBottom:'2%', minWidth: "200px", maxWidth: "495px"}}>
                                                            <div class="user-name" style={{color:"#333333"}} >{userDetails.first_name} {userDetails.last_name}</div>
                                                            <div class="user-loc" style={{marginBottom:"15px",fontSize:"13px",color:"#666666"}}>{userDetails.city && userDetails.city+', '} 
                                                            {userDetails.state && userDetails.state+', '} {userDetails.country && userDetails.country}</div>
                                                            <div class="user-loc" style={{marginBottom:"5px",fontSize:"12px",fontWeight:"700",color:"#666666"}}>Athlete Sports</div>
                                                            {/* {sportList.length > 0 ? (
                                                                <span className='profile-applied-course-tag-row' style={{padding: "0px", marginBottom: "15px"}}>
                                                                {sportList.map((item, index) => {
                                                                    return <><span className='profile-applied-course-tags'>{item['value']}</span></>
                                                                })}  
                                                                </span>
                                                            ) : (                                                            
                                                                <span className='profile-applied-course-tag-row' style={{padding: "0px", marginBottom: "15px"}}>
                                                                    <span className='profile-applied-course-tags' style={{color: "#999", fontStyle: "italic"}}>None selected</span>
                                                                </span>
                                                            )} */}
                                                           <span
                                                            className="profile-applied-course-tag-row"
                                                            style={{ padding: "0px", marginBottom: "15px" }}
                                                            >
                                                            {athleteSportlist.length > 0 ? (
                                                                athleteSportlist.map((item, index) => (
                                                                <span key={index} className="profile-applied-course-tags">
                                                                    {item}
                                                                </span>
                                                                ))
                                                            ) : (
                                                                <span
                                                                className="profile-applied-course-tags"
                                                                style={{ color: "#999", fontStyle: "italic" }}
                                                                >
                                                                None selected
                                                                </span>
                                                            )}
                                                            </span>
                                                                
                                                           
                                                              {/* Primary Position */}
                                                                        {/* <div><b>Primary Position</b></div> */}
                                                                        <div><b>{mergedData.field_athlete_position || "-"}</b></div>
                                                        </div>
<div className="agent-profile-right">
  {rightSectionFields.map((item) => {
    let value = mergedData?.[item.key];

   if (item.key === "height_weight") {
  const height = mergedData.field_athlete_height || "-";
  const heightUnit = mergedData.field_height_unit || "";

  const weight = mergedData.field_athlete_weight || "-";
  const weightUnit = mergedData.field_weight_unit || "";

  value = `${height}${heightUnit ? " (" + heightUnit + ")" : ""} / ${weight}${weightUnit ? " (" + weightUnit + ")" : ""}`;
}

    if (item.key === "field_dob") {
      value = `${mergedData.field_dob?.date || ""} ${mergedData.field_dob?.time || ""}`;
    }

    return (
      <div className="agent-profile-right-content" key={item.key}>
        <div className="agent-profile-right-content-label">
          {item.label}
        </div>
        <div className="agent-profile-right-content-value">
          {value || "-"}
        </div>
      </div>
    );
  })}
</div>

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{clear: "both"}}></div>
                                </div>
                            </div>

{/* <div className={`view-user-profile-section-header ${toggles["AgentJobTitle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("AgentJobTitle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Job Title</strong></span>
        </div>
    </div>
    {toggles.AgentJobTitle && (
        <div class="view-user-profile-section-body-container">
            <div class="opinion-header profile_summary view-agent-profile-section-content">
                <div className="agent-richtext-placeholder empty">No job title set.</div>
            </div>
        </div>
    )}
</div> */}

<div className={`view-user-profile-section-header ${toggles["athletedetails"] ? "open" : ""}`}>
    
    <div className="app-aspect-content" onClick={() => handleToggle("athletedetails")}>
        <div className="aspect-info">
            <span className="view-user-profile-section-heading">
                <strong>Athlete Details</strong>
            </span>
        </div>
    </div>

    {toggles.athletedetails && (
        <div className="view-user-profile-section-body-container">
            <div className="profile_summary_sentiment-wrapper view-user-profile-section-container">
                <div className="opinion-header profile_summary view-user-profile-section-content">

                    <table className="user-profile-summary-table">
                        <tbody>

                            {[
                                ["sport_played", "Sport Played"],
                                ["positions_played", "Primary Position"],
                               // ["field_athlete_type", "Athlete Type"],
                                ["specific_sport", "Specific Sport"],
                                ["university_attended", "University Attended"],
                                ["awards", "Awards"],
                                ["test_info", "Test Info"],
                                ["field_athelte_id", "Athlete ID"],
                                ["field_athlete_rank", "Athlete Rank"],
                                ["field_tier_status", "Tier Status"],
                                ["field_signing_agent_id", "Signing Agent ID"],
                                ["field_current_agent_id", "Current Agent ID"],
                            ].map(([key, label]) => {
                                let value = mergedData?.[key];

                                if (!value) return null;
                                const isHtmlField = ["field_signing_agent_id", "field_current_agent_id"].includes(key);

                                return (
                                    <tr key={key}>
                                        <td className="user-profile-summary-row" valign="top">
                                            <span className="user-profile-label">
                                                {label}:&nbsp;
                                            </span>
                                        </td>

                                        <td className="user-profile-summary-row" valign="top">
                                            <span className="user-profile-value">
                                                {isHtmlField ? (
                                                    <span dangerouslySetInnerHTML={{ __html: value }} />
                                                ) : (
                                                    value || "-"
                                                )}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}

                          
{/* Athlete Type Row */}
{mergedData?.field_athlete_type && (
    <tr>
        <td className="user-profile-summary-row">
            <span className="user-profile-label">Athlete Type:&nbsp;</span>
        </td>
        <td className="user-profile-summary-row">
            <span className="user-profile-value">
                {/* Use the helper to show the name instead of the number */}
                {getAthleteTypeLabel(mergedData.field_athlete_type)}
            </span>
        </td>
    </tr>
)}
                           

                            {/* Date of Signing */}
                            {(mergedData?.field_date_of_signing?.date || mergedData?.field_date_of_signing?.time) && (
                                <tr>
                                    <td className="user-profile-summary-row">
                                        <span className="user-profile-label">Date of Signing:&nbsp;</span>
                                    </td>
                                    <td className="user-profile-summary-row">
                                        <span className="user-profile-value">
                                            {mergedData.field_date_of_signing?.date} {mergedData.field_date_of_signing?.time}
                                        </span>
                                    </td>
                                </tr>
                            )}

                            {/* Date of Assignment */}
                            {(mergedData?.field_date_of_assignment?.date || mergedData?.field_date_of_assignment?.time) && (
                                <tr>
                                    <td className="user-profile-summary-row">
                                        <span className="user-profile-label">Date of Assignment:&nbsp;</span>
                                    </td>
                                    <td className="user-profile-summary-row">
                                        <span className="user-profile-value">
                                            {mergedData.field_date_of_assignment?.date} {mergedData.field_date_of_assignment?.time}
                                        </span>
                                    </td>
                                </tr>
                            )}

                            {/* Tier Status Date */}
                            {(mergedData?.field_tier_status_date?.date || mergedData?.field_tier_status_date?.time) && (
                                <tr>
                                    <td className="user-profile-summary-row">
                                        <span className="user-profile-label">Tier Status Date:&nbsp;</span>
                                    </td>
                                    <td className="user-profile-summary-row">
                                        <span className="user-profile-value">
                                            {mergedData.field_tier_status_date?.date} {mergedData.field_tier_status_date?.time}
                                        </span>
                                    </td>
                                </tr>
                            )}
                     {/* Athlete Contract Section */}
{athleteAssets.find(item => item.key === 'field_athlete_contract')?.full_value?.map((file, index) => (
    <tr key={`contract-${index}`}>
        <td className="user-profile-summary-row">
            <span className="user-profile-label">
                {index === 0 ? "Athlete Contract:" : ""}&nbsp;
            </span>
        </td>
        <td className="user-profile-summary-row">
            <span className="user-profile-value">
                <img 
                    src="/basic/web/images/image-x-generic.png" 
                    alt="icon" 
                    style={{ width: '16px', marginRight: '5px', verticalAlign: 'middle' }} 
                />
                <a href={file.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>
                    {file.name}
                </a>
            </span>
        </td>
    </tr>
))}
{/* Status & Visibility - Showing all fields with Yes/No status */}
{athleteAssets
    .filter(item => 
        [
            'field_show_on_frontend_athlete', 
            'field_current_class', 
            'field_athlete_featured', 
            'field_available', 
            'field_show_on_smww_basketball'
        ].includes(item.key)
    )
    .map((item) => (
        <tr key={item.key}>
            <td className="user-profile-summary-row">
                <span className="user-profile-label">{item.label}:&nbsp;</span>
            </td>
            <td className="user-profile-summary-row">
                <span className="user-profile-value">
                    {/* Ternary: If value is 1 show Yes, otherwise show No */}
                    {Number(item.value) === 1 ? "Yes" : "No"}
                </span>
            </td>
        </tr>
    ))
}

                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    )}
</div>
{sections.map((section) => {
//   const content = backEndData?.[section.key];
const content = mergedData?.[section.key];

  return (
    <div
      key={section.keyToggle}
      className={`view-user-profile-section-header ${
        toggles[section.keyToggle] ? "open" : ""
      }`}
    >
      <div
        className="app-aspect-content"
        onClick={() => handleToggle(section.keyToggle)}
      >
        <div className="aspect-info">
          <span className="view-user-profile-section-heading">
            <strong>{section.title}</strong>
          </span>
        </div>
      </div>

      {toggles[section.keyToggle] && (
        <div className="view-user-profile-section-body-container">
          <div
            className={`opinion-header profile_summary view-agent-profile-section-content ${
              section.customClass || ""
            }`}
          >
            {content ? (
              <div
                // className="agent-richtext-placeholder"
                className={`agent-richtext-placeholder ${section.customClass2 || ""}`}
                dangerouslySetInnerHTML={{ __html: content }}
              />
            ) : (
              <div className="agent-richtext-placeholder empty">
                {section.emptyText}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
})}

<div className={`view-user-profile-section-header ${toggles["socialMediaToggle"] ? "open" : ""}`}>
    <div class="app-aspect-content" onClick={() => handleToggle("socialMediaToggle")}>
        <div class="aspect-info">
            <span class="view-user-profile-section-heading"><strong>Social Media</strong></span>
        </div>
    </div>
    {toggles.socialMediaToggle && (
    <div className="view-user-profile-section-body-container">
        {socialAssets &&
        Object.keys(socialAssets).length > 0 ? (
        <div className="profile_summary_sentiment-wrapper view-user-profile-section-container">
            <div className="opinion-header profile_summary view-user-profile-section-content">
            <table className="user-profile-summary-table">
                <tbody>
                {[
                    ['field_instagram_url', 'Instagram URL'],
                    ['field_instagram_handle', 'Instagram Handle'],
                    ['field_facebook_url', 'Facebook URL'],
                    ['field_facebook_handle', 'Facebook Handle'],
                    ['field_twitter_url', 'Twitter URL'],
                    ['field_user_youtube_url', 'YouTube URL'],
                    ['field_linkedin_url', 'LinkedIn URL'],
                    ['field_linkedin_handle', 'LinkedIn Handle'],
                ].map(([key, label]) => {
                    const value = socialAssets[key];

                    // optional: skip empty values
                    if (!value) return null;

                    return (
                    <tr key={key}>
                        <td className="user-profile-summary-row" valign="top">
                        <span className="user-profile-label">
                            {label}:&nbsp;
                        </span>
                        </td>

                        <td className="user-profile-summary-row" valign="top">
                        <span className="user-profile-value">
                            {value || "-"}
                        </span>
                        </td>
                    </tr>
                    );
                })}
                </tbody>
            </table>
            </div>
        </div>
        ) : (
        <div className="opinion-header profile_summary view-agent-profile-section-content">
            <div className="agent-richtext-placeholder empty">
            No social media content.
            </div>
        </div>
        )}
    </div>
    )}
</div>



{/* {sections.map((section) => {
    const content = backEndData?.[section.key]; //  dynamic backend binding

    return (
        <div
        key={section.keyToggle}
        className={`view-user-profile-section-header ${
            toggles[section.keyToggle] ? "open" : ""
        }`}
        >
            <div
                className="app-aspect-content"
                onClick={() => handleToggle(section.keyToggle)}
            >
                <div className="aspect-info">
                    <span className="view-user-profile-section-heading">
                        <strong>{section.title}</strong>
                    </span>
                </div>
            </div>

            {toggles[section.keyToggle] && (
                <div className="view-user-profile-section-body-container">
                    <div className="opinion-header profile_summary view-agent-profile-section-content">
                        
                        {content ? (
                            <div className="agent-richtext-placeholder" dangerouslySetInnerHTML={{ __html: content }} />
                        ) : (
                            <div className="agent-richtext-placeholder empty">
                                {section.emptyText}
                            </div>
                        )}

                    </div>
                </div>
            )}
        </div>
    );
})} */}
 </>) : (
      <EditAthlete uid={uid}  userLoggedInRoles={userLoggedInRoles} userDetails={userDetails} userAthleteAssets={athleteAssets} />
      
      )}
</>
        )}
        </>
    );
};

export default ViewAthleteProfile;